export default {
  "nav.home": "Inicio",
  "nav.categories": "Categorías",
  "nav.articles": "Guías",
  "nav.faq": "FAQ",
  "nav.shopGuide": "Guía de compras",

  "hero.eyebrow": "USFans Spreadsheet y Centro de Recursos",
  "hero.title": "USFans Spreadsheet — encuentra, explora y compara recursos de USFans",
  "hero.subtitle": "Encuentra recursos organizados de la hoja de cálculo USFans, listas de creadores, reseñas, guías de envío, cupones y comparaciones — todo en un centro fácil de navegar.",
  "hero.ctaPrimary": "USFans Spreadsheet",
  "hero.ctaSecondary": "Comprar ahora",
  "hero.trust": "Recurso independiente • Información actualizada • Enfoque en seguridad",
  "hero.searchPlaceholder": "Busca hojas de cálculo, creadores, envíos, cupones, reseñas...",

  "categories.title": "Explorar por categoría",
  "categories.subtitle": "Salta directamente a los productos que buscas en la tienda principal.",
  "categories.dropdownLabel": "Selecciona una categoría",
  "categories.view": "Ver categoría",

  "articles.title": "USFans Spreadsheet: guías y recursos",
  "articles.subtitle": "Lee nuestras guías detalladas para entender cómo funcionan los recursos de la hoja de cálculo USFans, las listas de creadores y las comparaciones.",
  "articles.readMore": "Leer la guía completa",

  "faq.title": "Preguntas frecuentes",
  "faq.subtitle": "Respuestas rápidas y prácticas sobre los recursos de la hoja de cálculo USFans.",

  "cta.title": "¿Listo para explorar los recursos de USFans?",
  "cta.subtitle": "Explora nuestros recursos de la hoja de cálculo USFans, guías, comparaciones e información de seguridad — y luego dirígete a la tienda principal.",

  "footer.desc": "USFansLink es un centro de recursos independiente con enlaces a hojas de cálculo USFans, listas de creadores, reseñas, guías de envío, cupones y comparaciones.",
  "footer.disclaimer": "USFansLink es un recurso de información independiente. No estamos afiliados a ninguna marca salvo que se indique explícitamente.",
  "footer.rights": "Todos los derechos reservados.",
  "footer.explore": "Explorar",
  "footer.categories": "Categorías",
  "footer.language": "Idioma",

  "category.shoes": "Zapatos",
  "category.hoodies": "Sudaderas/Jerséis",
  "category.tshirts": "Camisetas",
  "category.jackets": "Chaquetas",
  "category.pants": "Pantalones/Shorts",
  "category.headwear": "Gorros",
  "category.sets": "Conjuntos",
  "category.underwear": "Ropa interior",
  "category.jersey": "Camiseta deportiva",
  "category.accessories": "Accesorios",
  "category.bags": "Bolsos",
  "category.belts": "Cinturones",
  "category.perfumes": "Perfumes",
  "category.other": "Otras cosas",

  "common.backHome": "Volver al inicio",
  "common.readArticle": "Leer artículo",
  "common.published": "Publicado",
  "common.updated": "Actualizado",
  "common.author": "Autor",
  "common.readTime": "min de lectura",
  "common.onThisPage": "En esta página",
  "common.relatedResources": "Recursos relacionados",
  "common.quickAnswer": "Respuesta rápida",
  "common.faqShort": "FAQ",
};